module.exports = __webpack_public_path__ + "img/fig1.304b7e46.png";